import { Check, ChevronRight } from 'lucide-react';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger
} from '@design-system/Sheet.tsx';

interface L4CardProps {
  title: string;
  description: string;
}

export const L4Card = ({ title, description }: L4CardProps) => {
  return (
    <Sheet>
      <SheetTrigger>
        <div className="bg-white rounded-xl p-4 flex items-center justify-between w-full">
          <div className="flex items-center gap-3">
            <div className="w-5 h-5 rounded-full bg-background-success flex items-center justify-center">
              <Check className="w-3 h-3 text-white" />
            </div>
            <span className="typography-body text-primary line-clamp-1 text-start">
              {title}
            </span>
          </div>
          <ChevronRight className="w-5 h-5 text-primary" />
        </div>
      </SheetTrigger>
      <SheetContent>
        <SheetHeader>
          <SheetTitle className='text-primary typography-h1 px-6'>
            {title}
          </SheetTitle>
          <SheetDescription className='typography-body text-secondary'>
            {description}
          </SheetDescription>
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};